import React from 'react';
import { KeyboardDatePicker, KeyboardDatePickerProps } from '@material-ui/pickers';
import dayjs from 'dayjs';
import { Control, Controller } from 'react-hook-form';
import { useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

type FormDatePickerProps = {
  name: string;
  label?: string;
  control: Control<any>;
} & Partial<KeyboardDatePickerProps>;

const useStyles = makeStyles(() =>
  createStyles({
    adornedEnd: {
      paddingRight: 0,
    },
  }),
);

export default function FormDatePicker(props: FormDatePickerProps) {
  const { name, control, ...rest } = props;
  const classes = useStyles();

  const isMobile = useMediaQuery('(max-width: 800px)');

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <KeyboardDatePicker
          {...field}
          {...rest}
          format="MM/DD/YYYY"
          variant="inline"
          inputVariant="outlined"
          size="small"
          margin="normal"
          fullWidth
          value={field.value ? dayjs(field.value).toDate() : null}
          onChange={(date) => {
            const iso = date ? dayjs(date).format('MM/DD/YYYY') : '';
            field.onChange(iso);
          }}
          InputProps={{ classes: { adornedEnd: classes.adornedEnd } }}
          InputLabelProps={isMobile ? { shrink: true } : undefined}
          style={{ margin: 0 }}
        />
      )}
    />
  );
}
